import { aplicationConstants } from '../constants/applications';

const initialState = {
  applications: null,
  selected: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case aplicationConstants.SET_APPLICATIONS_SUCCESS:
      return {...state, applications: action.apps, selected: {}}
    case aplicationConstants.SET_SELECTED_APPLICATION_SUCCESS:
      return {...state, selected: action.app}
    case aplicationConstants.SET_SELECTED_APPLICATION_FAILURE:
      return {...state, selected: {}}  
    default:
      return state;
  }
};
